enum PERMISSIONS {
    CAN_VIEW_DASHBOARD = "view_dashboard",
    CAN_VIEW_PROFILE = "view_profile"
};
export default PERMISSIONS;
  